import helpers from "../helpers/helpers";
export default {
  modelName: 'user_organization_template_role',
  label: '預設集團角色管理',
  fields: {
    id: {
      type: 'text',
      label: 'ID',
      readonly: true,
    },
    sequence: {
      type: 'text',
      label: '排序',
      maxlength: 10,
    },
    is_active: {
      type: 'switch',
      label: '',
      defaultValue: true,
      activeText: '顯示',
      inactiveText: '隱藏',
    },
    locales: {
      type: 'locales',
      fields: {
        name: {
          type: 'text',
          label: '角色名稱',
          rules: 'required',
        },
      }
    },
    name: {
      type: 'text',
      label: '角色名稱',
      rules: 'required',
    },
    organization: {
      type: 'factory',
      label: '適用集團',
      fields: {
        name: {
          label: '適用集團',
          type: 'text',
        },
      },
    },
    organizations: {
      label: '適用集團',
      type: 'hasMany',
      textKey: 'name',
      modelName: 'organization',
      orderBy: 'created_at',
      orderWay: 'asc',
      noReset: true,
      hasCloseChips: true,
      getText: (item) => {
        return helpers.methods.$_CMS_getFactoryName(item)
      },
      displayCheck: (modelData) => {
        return modelData.is_default !== undefined ? modelData.is_default : (modelData.organizations !== undefined ? true : modelData.is_default);
      },
    },
    created_at: {
      type: 'datetime',
      label: '建立時間',
      readonly: true,
      textKey: 'name',
    },
    created_admin: {
      type: 'belongsTo',
      label: '建立者',
      readonly: true,
      textKey: 'name',
    },
    updated_at: {
      type: 'datetime',
      label: '最後更新時間',
      readonly: true,
    },
    updated_admin: {
      type: 'belongsTo',
      label: '最後更新人',
      readonly: true,
      textKey: 'name',
      modeldataName: 'admin',
    },
    updated_info: {
      type: 'custom',
      label: '上次修改時間',
      getValue: (item) => {
        let _value = item.updated_at;
        if (item.updated_admin) {
          _value += `  ${item.updated_admin}`;
        }
        return _value;
      },
    },
    tags: {
      label: '全域標籤設定',
      type: 'hasMany',
      inLocale: true,
      textKey: 'name',
      modelName: 'tag',
      // valueKey: "name"
    },
    is_default: {
      type: 'switch',
      label: '客製',
      defaultValue: true,
      activeText: '是',
      inactiveText: '否',
    },
    dashboard: {
      type: 'checkbox',
      label: '',
      items: [
        {
          value: [
            'organization-dashboard-read',
          ],
          text: '集團概況',
        },
      ],
    },
    broadcast: {
      type: 'checkbox',
      label: '',
      items: [
        {
          value: ['llbroadcast-read'],
          text: 'ESGoal快報',
        },
      ],
    },
    factories: {
      type: 'checkbox',
      label: '',
      items: [
        {
          value: ['factory-dashboard-read'],
          text: '各廠概況',
        },
      ],
    },
    user: {
      type: 'checkbox',
      label: '',
      items: [
        {
          value: ['user-organization-manage'],
          text: '成員管理',
        },
      ],
    },
    role: {
      type: 'checkbox',
      label: '',
      items: [
        {
          value: ['organization-role-manage'],
          text: '角色管理',
        },
      ],
    },
    sos_request: {
      type: 'checkbox',
      label: '',
      multipleValue: true,
      items: [
        {
          value: ['sos-create'],
          text: 'SOS',
        },
      ],
    },
  },
};
